// The 45-day pilot drawn to scale: two weeks of watching, then a month of running on
// its own, with a dot for each week. The home page and /specialists each say it in
// their own words. On a phone the text stacks in order of time, under the line.
import React from "react";
import "./PilotTimeline.css";

const PILOT_DAYS = 45;
const WEEKLY_DAYS = [7, 14, 21, 28, 35, 42];

function Item({ kind, item }) {
  return (
    <div className={`pilotItem pilotItem-${kind}`}>
      <span className="pilotWhen">{item.when}</span>
      <h3>{item.title}</h3>
      {item.text ? <p>{item.text}</p> : null}
    </div>
  );
}

export default function PilotTimeline({ start, watch, run, weekly, end }) {
  return (
    <div className="pilotTimeline reveal" data-reveal>
      <div className="pilotRail" aria-hidden="true">
        <div className="pilotRailFill">
          <i className="pilotRailWatch" />
          <i className="pilotRailRun" />
        </div>
        {WEEKLY_DAYS.map((day) => (
          <b key={day} style={{ left: `${(day / PILOT_DAYS) * 100}%` }} />
        ))}
        <em />
        <span className="pilotRailDay" style={{ left: 0 }}>
          Day 1
        </span>
        <span className="pilotRailDay" style={{ left: `${(14 / PILOT_DAYS) * 100}%` }}>
          Day 15
        </span>
        <span className="pilotRailDay pilotRailDayEnd">Day 45</span>
      </div>
      <Item kind="start" item={start} />
      <Item kind="watch" item={watch} />
      <Item kind="run" item={run} />
      <Item kind="weekly" item={weekly} />
      <Item kind="end" item={end} />
    </div>
  );
}
